import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.values";
import _classCallCheck from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/createClass";
import _inherits from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Extensions
import { Service } from "../service";
export var Application = /*#__PURE__*/function (_Service) {
  _inherits(Application, _Service);

  var _super = _createSuper(Application);

  function Application() {
    var _this;

    _classCallCheck(this, Application);

    _this = _super.apply(this, arguments);
    _this.bar = 0;
    _this.top = 0;
    _this.left = 0;
    _this.insetFooter = 0;
    _this.right = 0;
    _this.bottom = 0;
    _this.footer = 0;
    _this.application = {
      bar: {},
      top: {},
      left: {},
      insetFooter: {},
      right: {},
      bottom: {},
      footer: {}
    };
    return _this;
  }

  _createClass(Application, [{
    key: "register",
    value: function register(uid, location, size) {
      this.application[location][uid] = size;
      this.update(location);
    }
  }, {
    key: "unregister",
    value: function unregister(uid, location) {
      if (this.application[location][uid] == null) return;
      delete this.application[location][uid];
      this.update(location);
    }
  }, {
    key: "update",
    value: function update(location) {
      this[location] = Object.values(this.application[location]).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }
  }]);

  return Application;
}(Service);
Application.property = 'application';